var req = require.context('../../../asset/mapdata');
req.keys().forEach((file) => {
   // console.debug(`Loading map data file ${file}`);
   req(file);
});
